import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import type { TFormQuestion } from '@onesource/services';

interface TrueFalseQuestionProps {
  question: TFormQuestion;
  selectedOptionIds: string[];
  onSelect: (optionIds: string[]) => void;
  disabled?: boolean;
}

export const TrueFalseQuestion = ({
  question,
  selectedOptionIds,
  onSelect,
  disabled = false,
}: TrueFalseQuestionProps) => {
  const sortedOptions = [...question.options].sort((a, b) => a.position - b.position);

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
      {sortedOptions.map(option => {
        const isSelected = selectedOptionIds.includes(option.id);
        return (
          <ButtonBase
            key={option.id}
            disabled={disabled}
            onClick={() => onSelect([option.id])}
            sx={{
              flex: { xs: '1 1 100%', sm: '1 1 0' },
              minWidth: { sm: 180 },
              maxWidth: { sm: 280 },
              p: 2,
              borderRadius: 2,
              border: '2px solid',
              borderColor: isSelected ? '#ff4d6d' : 'rgba(0,0,0,0.12)',
              bgcolor: isSelected ? '#ff4d6d' : 'white',
              color: isSelected ? 'white' : 'inherit',
              boxShadow: isSelected ? '0 4px 12px rgba(255,77,109,0.25)' : '0 2px 8px rgba(0,0,0,0.06)',
              transition: 'all 0.15s ease',
              '&:hover': disabled
                ? {}
                : {
                    borderColor: '#ff4d6d',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 6px 14px rgba(0,0,0,0.1)',
                  },
              '&.Mui-disabled': {
                opacity: 0.6,
              },
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: '1rem' }}>{option.optionText}</Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
};
